// extracted by mini-css-extract-plugin
module.exports = {"recommendedFit":"uu","sizeIndicatorIcon":"vu","recommendedFitContainer":"wu","calculateSize":"xu"};